module.exports = __webpack_public_path__ + "static/media/Telegram.d5d0b0a4.png";